var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.5L2.06021 21.1583C1.92743 21.5234 2.01816 21.9324 2.29289 22.2071C2.56762 22.4818 2.97661 22.5726 3.34174 22.4398L3 21.5ZM8.5 19.5L8.84174 20.4398L9.05024 20.364L9.20711 20.2071L8.5 19.5ZM5 16L4.29289 15.2929L4.13602 15.4498L4.06021 15.6583L5 16ZM19.9142 3.91421L19.2071 4.62132L19.9142 3.91421ZM17.0858 3.91421L16.3787 3.20711L17.0858 3.91421ZM20.5858 4.58579L19.8787 5.29289L20.5858 4.58579ZM3.34174 22.4398L8.84174 20.4398L8.15826 18.5602L2.65826 20.5602L3.34174 22.4398ZM9.20711 20.2071L21.2929 8.12132L19.8787 6.70711L7.79289 18.7929L9.20711 20.2071ZM21.2929 3.87868L20.6213 3.20711L19.2071 4.62132L19.8787 5.29289L21.2929 3.87868ZM16.3787 3.20711L4.29289 15.2929L5.70711 16.7071L17.7929 4.62132L16.3787 3.20711ZM4.06021 15.6583L2.06021 21.1583L3.93979 21.8417L5.93979 16.3417L4.06021 15.6583ZM20.6213 3.20711C19.4497 2.03553 17.5503 2.03553 16.3787 3.20711L17.7929 4.62132C18.1834 4.2308 18.8166 4.2308 19.2071 4.62132L20.6213 3.20711ZM21.2929 8.12132C22.4645 6.94975 22.4645 5.05025 21.2929 3.87868L19.8787 5.29289C20.2692 5.68342 20.2692 6.31658 19.8787 6.70711L21.2929 8.12132Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilOutline);
export default __webpack_public_path__ + "static/media/pencil-outline.59b191b139cae59daf1758a491f11685.svg";
export { ForwardRef as ReactComponent };